import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_TAGS_ACTION_TYPE } from '../actions';

const initialState = {};

const loanTagsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_TAGS_ACTION_TYPE.GET_LOAN_TAGS:
        return payload || initialState;

      case LOAN_TAGS_ACTION_TYPE.CREATE_LOAN_TAG_ASSIGNMENT:
        return { ...state, ...payload };

      case LOAN_TAGS_ACTION_TYPE.DELETE_LOAN_TAG_ASSIGNMENT: {
        const isSoftDelete = !!payload?.pendingChange;

        if (isSoftDelete) {
          draft[payload.tagId] = payload;

          break;
        }

        delete draft[payload.tagId];
        break;
      }

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanTagsReducer;
